import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import {
  LocalMediaStorage,
  MediaPlayer,
  MediaProvider,
  Poster,
  Track,
  PlayButton,
  useMediaState,
  Src,
} from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import * as styles from "./Video.css";
import {
  ComponentPropsWithRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Image } from "./Image";
import clsx from "clsx";
import { VideoContext } from "~/lib/context/VideoContext";
import IconPlay from "~/assets/svgs/icons/IconPlay";
import IconPause from "~/assets/svgs/icons/IconPause";
import { ButtonIcon } from "./ButtonIcon";
import { useLocalStorage } from "usehooks-ts";

export type VideoProps = {
  setVidDuration?: React.Dispatch<React.SetStateAction<number | undefined>>;
  textTracks?: ComponentPropsWithRef<typeof Track>[];
  hasPlayButton?: boolean;
  showPauseOnHover?: boolean;
  hasRef?: boolean;
} & Omit<ComponentPropsWithRef<typeof MediaPlayer>, "children">;

export const Video = ({
  className,
  setVidDuration,
  textTracks,
  hasPlayButton = true,
  showPauseOnHover = true,
  hasRef = true,
  ...props
}: VideoProps) => {
  const mediaRef = useContext(VideoContext);
  const defaultMediaRef = useRef(null);
  const paused = useMediaState("paused", mediaRef);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showPoster, setShowPoster] = useState(true);

  const loaded = () => {
    setTimeout(() => {
      setIsLoaded(true),
        setVidDuration && setVidDuration(mediaRef.current?.duration);
    }, 300);
    setTimeout(() => {
      if (mediaRef.current) {
        mediaRef.current.currentTime = 0;
      }
    });
    setTimeout(() => {
      setShowPoster(false);
    }, 750);
  };

  useEffect(() => {
    setTimeout(() => {
      setShowVideo(true);
    });
  }, []);
  // console.log(props.muted);
  // console.log(isMute);

  class CustomMediaStorage extends LocalMediaStorage {
    async getTime() {
      return null;
    }

    onChange(src: Src, mediaId: string | null, playerId?: string): void {
      this.setMuted(isMute == true ? true : props.muted == true ? true : false);
    }

    async setTime() {
      // no-op
    }
  }

  const [isMute] = useLocalStorage("isMute", false);
  const textTrackDefaults: ComponentPropsWithRef<typeof Track> = {
    label: "English",
    language: "en-AU",
    kind: "subtitles",
    type: "vtt",
    default: false,
  };

  return (
    <div className={styles.root}>
      {/* Poster container needed so there is no layout shift if no poster image is provided for load */}
      {showPoster && (
        <div
          // style={{ display: isLoaded ? "none" : "flex" }}
          className={styles.posterContainer}
        >
          {props.poster && (
            <Image
              className={clsx(className, styles.poster)}
              src={props.poster}
              // style={{ display: isLoaded && showVideo ? "none" : "flex" }}
            />
          )}
        </div>
      )}

      <MediaPlayer
        {...props}
        // viewType="video"
        ref={hasRef ? mediaRef : defaultMediaRef}
        aspectRatio="16/9"
        playsInline
        className={clsx(className, styles.video)}
        controls={false}
        keyShortcuts={{
          togglePaused: "Space",
        }}
        load="eager"
        posterLoad="eager"
        onLoadedData={() => loaded()}
        style={{
          display: isLoaded ? "flex" : "none",
          containerType: "inline-size",
        }}
        muted={isMute == true ? true : props.muted == true ? true : false}
        storage={new CustomMediaStorage()}
        crossOrigin="anonymous"
      >
        {showVideo && (
          <MediaProvider
            style={{
              backgroundColor: "white",
              backgroundImage: `url(${props.poster})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {props.poster && (
              <Poster
                className={clsx("vds-poster", styles.poster)}
                src={props.poster}
              />
            )}
            {textTracks?.map((track) => (
              <Track {...{ ...textTrackDefaults, ...track }} key={track.src} />
            ))}
          </MediaProvider>
        )}
        <DefaultVideoLayout icons={defaultLayoutIcons}>
          <PlayButton
            className={styles.playButton({
              paused: paused,
              showPauseOnHover: showPauseOnHover,
            })}
            asChild
          >
            <div>
              {hasPlayButton && (
                <ButtonIcon
                  // className={styles.button({
                  //   isPaused: paused,
                  // })}
                  icons={{
                    iconPrimary: paused ? IconPlay : IconPause,
                    iconSecondary: paused ? IconPause : IconPlay,
                  }}
                  hasBackground
                  size="Xxl"
                  type="button"
                ></ButtonIcon>
              )}
            </div>
          </PlayButton>
        </DefaultVideoLayout>
      </MediaPlayer>
    </div>
  );
};
